<template>
  <div>
    <PFileUpload
      class="g-file-upload"
      :multiple="arquivoMultiplo"
      :accept="aceitos"
      :customUpload="customUpload"
      @uploader="upload"
      uploadLabel = "Enviar"
    >
    </PFileUpload>
                <g-button
                  tipo="cinza"
                  altura="35px"
                  largura="8em"
                  negritoTexto
                  tamanhoTexto="15px"
                  class="e-button"
                  @click="edit()"
                  >
                    EDITAR
                  </g-button>
  </div>
</template>

<script>
import gFileUpload from "./g-file-upload.js";
export default gFileUpload;
</script>

<style scoped>
.e-button {
  margin-top: 10px;
  margin-left: 10px;
}

:deep(.p-button) {
  background: #fcb316;
  color: #4f2c19;
  border-radius: 8px;
  border-color: #fcb316;
  border: 1px solid #f3c821;
}

.g-file-upload {
  width: v-bind("largura");
  height: v-bind("altura");
}

:deep(.p-fileupload-choose:not(.p-disabled):hover, .p-fileupload-choose:not(.p-disabled):active) {
  background: #fcb316;
  color: #4f2c19;
  border-radius: 8px;
  border-color: #fcb316;
  border: 1px solid #f3c821;
  box-shadow: none !important;
}

</style>
